import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ViewSellerListingService {

    constructor(private _http: HttpClient) { }
    viewsellerlisting(data) {
        return this._http.post(environment.api_url+'admin/seller/product/listing', data);
    }

    deletesellerlisting(data) {
        return this._http.post(environment.api_url+'admin/seller/product/delete', data);
    }

}
